<template>
  <VueDragResize
    ref="OADrag"
    class="VueDragResize"
    :sticks="['mr']"
    :w="dragWidth"
    :minw="minWidth"
    :isActive="true"
    :isDraggable="false"
  >
    <slot></slot>
  </VueDragResize>
</template>
<script>
import VueDragResize from "vue-drag-resize";
export default {
  name: "OADrag",
  components: { VueDragResize },
  data() {
    return {
      dragWidth: 300
    };
  },
  props: {
    col: {
      default: 300
    },
    minWidth: {
      default: null
    }
  },
  methods: {
    setClass() {
      let elements = document.getElementsByClassName("vdr-stick vdr-stick-mr");
      _.each(elements, item => {
        item.className += " iconfont icon-Group";
      });
    },
    getWidth(val) {
      if (typeof val === "number") {
        this.dragWidth = val;
      } else if (typeof val === "string") {
        let parentWidth = this.$refs.OADrag.$parent.$parent.$el.offsetWidth;
        this.dragWidth = (parentWidth / 24) * val;
      }
    }
  },
  mounted() {
    this.setClass();
    this.getWidth(this.col);
  }
};
</script>
<style lang="scss">
.VueDragResize {
  position: relative !important;
  margin-right: 10px;
  height: 100% !important;
  &.active:before {
    outline: none !important;
  }
  .vdr-stick.vdr-stick-mr {
    top: 16px !important;
    right: 8px !important;
    border: none !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    width: auto !important;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/OADrag/OADrag.vue